<div class="navbar-toolbar">
  <div class="navbar-toolbar-container">
    <div class="navbar-toolbar-left">
    <button mat-icon-button color="primary" style="line-height: 0">
      <mat-icon (click)="toggleLeftNav()">menu</mat-icon>
    </button>

    <ng-container *ngFor="let config of pathsConfig" >
      <a *ngIf="!config.disabled && config.link"  [disabled]="config.disabled" mat-button href="{{config.link}}">
        <ng-container *ngIf="!config.url">
          <span> {{config.name}}</span>
        </ng-container>
        <ng-container *ngIf="config.url">
          <span class="navbar-logo bg">
            <img src="{{config.url}}" alt="">
          </span>
        </ng-container>
      </a>
      <a *ngIf="currentConfig === config && !config.disabled && !config.link" [disabled]="config.disabled" [routerLink]="config?.route" mat-button (click)="changeSidebar(config)" class="orange-text">
        <ng-container *ngIf="!config.url">
<!--        <mat-icon class="orange-icon">{{config.icon}}</mat-icon>-->
        <span> {{config.name}}</span>
        </ng-container>
        <ng-container *ngIf="config.url">
          <span class="navbar-logo bg">
            <img src="{{config.url}}" alt="">
          </span>
        </ng-container>
      </a>
      <a *ngIf="currentConfig !== config && !config.disabled && !config.link" [disabled]="config.disabled" [routerLink]="config?.route" mat-button (click)="changeSidebar(config)">
        <ng-container *ngIf="!config.url">
<!--          <mat-icon class="orange-icon">{{config.icon}}</mat-icon>-->
          <span> {{config.name}}  </span>
        </ng-container>
        <ng-container *ngIf="config.url">
          <span class="navbar-logo">
            <img src="{{config.url}}" alt="">
          </span>
        </ng-container>
      </a>
    </ng-container>

    <button class="control-test" *ngIf="controlTest()" mat-flat-button color="primary">{{controlText}}</button>
    </div>
<!--    <app-login-lock-timer *ngIf="profile?.loginLock"></app-login-lock-timer>-->
    <div class="navbar-right-buttons" *ngIf="profile">

      <a *ngIf="(userApplications | async).asf360.active && !isDisabled" mat-button  [href]="'/rest/sso/api/redirect-token/360'" matTooltip="ASF360"><img [width]="73" src="assets/nav-asf360.png"></a>
      <a *ngIf="(userPermissions | async).meeting.read && !isDisabled" mat-button (click)="openCalendar()" matTooltip="Kalendarz"><mat-icon class="orange-icon">calendar_month</mat-icon></a>
      <a mat-button (click)="openDialog()" matTooltip="Zgłoszenia" ><mat-icon class="orange-icon">add_task</mat-icon></a>
      <ng-container *ngIf="disableLinks" >
      <a
        mat-button
        href="https://asfcompl.atlassian.net/servicedesk/customer/portals"
        target="_blank"
      >
        <mat-icon class="orange-icon">new_releases</mat-icon>
        Dodaj zgłoszenie
      </a>
      </ng-container>
      <button mat-button [matMenuTriggerFor]="menu" aria-label="Menu">
        <mat-icon>expand_more</mat-icon>
        <span *ngIf="profile"> {{ profile.username }}</span>
        <span class="navbar-avatar circular-image" *ngIf="profile.avatarLocation">
          <img class="circular-image small-avatar" src="/rest/sso/api/user/{{profile.userId}}/avatar" alt="Zdjęcie"/>
        </span>
        <mat-icon *ngIf="!profile.avatarLocation" class="orange-icon">person_outline</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button (click)="openProfileDialog()" mat-menu-item>
          <mat-icon class="orange-icon">manage_accounts</mat-icon>
          <span> Profil</span>
        </button>
        <button (click)="openChangePasswordDialog()" mat-menu-item>
          <mat-icon class="orange-icon">vpn_key</mat-icon>
          <span> Zmien hasło</span>
        </button>
        <button mat-menu-item
                (click)="openGoogleAuthenticatorDialog()"
                [disabled]="profile.googleAuthenticatorEnabled"
        >
          <mat-icon class="orange-icon" *ngIf="!profile.googleAuthenticatorEnabled">qr_code</mat-icon>
          <mat-icon class="orange-icon" *ngIf="profile.googleAuthenticatorEnabled">done</mat-icon>
          2FA
        </button>

<!--        <a-->
<!--          mat-menu-item-->
<!--          href="https://test.asf360.pl/home"-->
<!--          target="_blank"-->
<!--          *ngIf="profile.roles[0]==='ROLE_ADMIN' && checkProd()"-->
<!--        >-->
<!--          <mat-icon class="orange-icon" >360</mat-icon>-->
<!--          360-->
<!--        </a>-->

        <mat-divider></mat-divider>
        <button (click)="logout()" mat-menu-item>
          <mat-icon class="orange-icon">meeting_room</mat-icon>
          <span> Wyloguj</span>
        </button>
      </mat-menu>


      <button
        mat-icon-button [matMenuTriggerFor]="notificationsMenu"
        (click)="loadNotifications()"
      >
        <mat-icon
          [matBadge]="notificationService.notReadCount | async"
          matBadgeColor="warn"
          matBadgePosition="above before"
          [matBadgeHidden]="(notificationService.notReadCount | async) === 0"
        >notifications</mat-icon>
      </button>
      <mat-menu #notificationsMenu="matMenu" xPosition="before">
        <div class="notifications-list-container" fxLayout="column">
          <ng-container *ngIf="notifications | async">
            <ng-container *ngFor="let notification of (notifications | async).items" >
                <div class="notification-item" [ngClass]="{'notification-not-read' : !notification.read}"
                  (click)="$event.stopPropagation()" *ngIf="!notification.linkOption.includes('newsletter')&& !notification.linkOption.includes('selfBillingForm')">
                  <div class="notification-content" *ngIf="!notification.linkOption.includes('ofwca') && !notification.linkOption.includes('leaveApplication') &&!notification.linkOption.includes('contract') &&  !notification.linkOption.includes('selfBillingForm')">
                  {{notification.content}}
                </div>
                <div class="notification-content" *ngIf="notification.linkOption.includes('ofwca')">
                  <a class="default-link" [routerLink]="['/ofwca/szczegoly', notification.linkValue]">
                    {{notification.content}}
                  </a>
                </div>
                  <div class="notification-content" *ngIf="notification.linkOption.includes('leaveApplication')">
                    <a class="default-link" [routerLink]="['/kadry/wnioski-urlopowe/szczegoly', notification.linkValue]">
                      {{notification.content}}
                    </a>
                  </div>
                  <div class="notification-content" *ngIf="notification.linkOption.includes('contract')">
                    <a class="default-link" [routerLink]="['/umowy/szczegoly', notification.linkValue]">
                      {{notification.content}}
                    </a>
                  </div>
                  <div class="notification-date">
                    {{notification.createdAt | date:'y-MM-dd H:mm'}}
                  </div>

                  <div class="notification-file" *ngIf="notification.fileName">
                    <button
                      mat-icon-button color="accent"
                      (click)="downloadFile(notification)"
                    >
                      <mat-icon>file_download</mat-icon>
                    </button>
                    <span class="notification-filename">{{notification.fileName}}</span>
                  </div>

                  <button class="deleteButton" (click)="deleteNotifications(notification)" mat-button>
                    <mat-icon>cancel</mat-icon>
                  </button>

                </div>

                <div class="notification-item" [ngClass]="{'notification-not-read' : !notification.read}"
                  (click)="$event.stopPropagation()" *ngIf="(userPermissions | async).newsletter.read && notification.linkOption.includes('newsletter')">
                  <div class="notification-content">
                    {{notification.content}}
                  </div>
                  <div class="notification-date">
                    {{notification.createdAt | date:'y-MM-dd H:mm'}}
                  </div>
                  <div class="notifications-button">
                    <button mat-stroked-button color="primary" (click)="viewNewsletter(notification.linkValue)">
                      Podgląd Newslettera
                    </button>
                  </div>
                  <div class="notification-file" *ngIf="notification.fileName">
                    <button
                      mat-icon-button color="accent"
                      (click)="downloadFile(notification)"
                    >
                      <mat-icon>file_download</mat-icon>
                    </button>
                    <span class="notification-filename">{{notification.fileName}}</span>
                  </div>

                  <button class="deleteButton" (click)="deleteNotifications(notification)" mat-button color="primary"><mat-icon class="cancel">cancel</mat-icon></button>

                </div>
              <div class="notification-item" [ngClass]="{'notification-not-read' : !notification.read}"
                   (click)="$event.stopPropagation()" *ngIf="(userPermissions | async).newsletter.read && notification.linkOption.includes('selfBillingForm')">
                <div class="notification-content">
                  <a class="default-link" [routerLink]="['/umowy/zgloszenia-samofakturowanie']">
                    {{notification.content}}
                  </a>
                </div>
                <div class="notification-date">
                  {{notification.createdAt | date:'y-MM-dd H:mm'}}
                </div>


                <button class="deleteButton" (click)="deleteNotifications(notification)" mat-button color="primary"><mat-icon class="cancel">cancel</mat-icon></button>

              </div>
            </ng-container>

            <ng-container *ngIf="(notifications | async).items.length === 0">

              <div
                class="notification-item"
                (click)="$event.stopPropagation()"
              >
                <div class="notification-content notification-empty">
                  Brak powiadomień
                </div>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="!(notifications | async)">
            <div fxFlex="100" fxLayout="row">
              <mat-progress-spinner style="margin:0 auto;" mode="indeterminate"></mat-progress-spinner>
            </div>
          </ng-container>

          <div fxLayout="row">
            <button  class="cancel-all" (click)="deleteNotificationsAll()" mat-button>Wyczyść wszystko</button>

            <span fxFlex></span>

            <button
              mat-icon-button (click)="$event.stopPropagation(); previousPage()"
              [disabled]="notificationsPage < 1"
            >
              <mat-icon>navigate_before</mat-icon>
            </button>

            <span class="notifications-paginator-page">Strona {{notificationsPage + 1}}</span>

            <button mat-icon-button (click)="$event.stopPropagation(); nextPage()">
              <mat-icon>navigate_next</mat-icon>
            </button>
          </div>
        </div>
      </mat-menu>
    </div>
  </div>
</div>
